<div class="layout-column custom-panel full-width full-height">

  <!--Search Box-->
  <div class="layout-row layout-align-start-center padding-top-10 padding-left-10 padding-right-10 padding-bottom-5 search-header">

    <app-bringoz-search-input class="flex"
                              [query]="queryString"
                              (queryChangeEvent)="onQueryChange($event)">
    </app-bringoz-search-input>

    <div class="layout-row layout-align-start-center show-all-agents-toggle">
      <bringoz-switch [checked]="isExternalResourcesMode"
                      [name]="'showAllAgentsReassignRoute'"
                      [label]="'Show All Agents' | translate"
                      (onChange)="onToggleIsExternalResourcesMode($event)">
      </bringoz-switch>

      <bringoz-icon iconName="error-outline"
                    fill="#f44336"
                    classSize="lg"
                    class="margin-left-5 cursor-help show-all-agents-skills-tooltip-icon"
                    [tooltip]="'SHOW_ALL_AGENTS_SKILLS_TOOLTIP' | translate">
      </bringoz-icon>
    </div>

  </div>

  <hr class="main-divider">

  <div *ngIf="!isExternalResourcesMode" class="flex layout-column padding-left-10 padding-right-10 overflow-auto">

    <div class="layout-row layout-align-start-center option-row" *ngFor="let option of optionsToDisplay">
      <app-bringoz-radio-button [value]="option.resource.id"
                                [isSelected]="option.resource.id === selectedResourceId"
                                (onValueChange)="onSelectResource($event)">
      </app-bringoz-radio-button>

      <div class="flex margin-left-10">
          <span class="br-body-2 font-weight-400"
                style="display: block; overflow: hidden; color: var(--Grey-100, #292929); font-feature-settings: 'liga' off, 'clig' off; text-overflow: ellipsis; white-space: nowrap; font-family: Inter; font-size: 12px; line-height: 18px;">
            {{ option.resource.agentName }}
          </span>
      </div>
      <span class="flex"></span>
      <div class="flex-20">
        <app-bringoz-tags *ngIf="option.resource.agentTags?.length"
                          [tags]="option.resource.agentTags"
                          [maxTags]="1">
        </app-bringoz-tags>
      </div>
      <span class="flex"></span>
      <div class="score layout-row layout-align-start-center" [ngClass]="{'high': option.score >= 70, 'medium': (option.score < 70 || option.score > 41), 'low': option.score < 40}">
        <span>{{option.score}}%</span>
      </div>

    </div>

    <div *ngIf="!isLoading && optionsToDisplay.length === 0" class="br-body-2 font-weight-400 gray-102 text-center margin-top-20">
      {{ 'No resources available' | translate }}
    </div>
  </div>

  <div *ngIf="!!isExternalResourcesMode" class="flex layout-row external-assign-layout">
    <app-visit-plan-external-agents-resource-holders-single-select-list class="flex"
                                                                        [queryString]="queryString"
                                                                        [hideSearch]="true"
                                                                        [visitPlanId]="data.visitPlan.id"
                                                                        [visitScheduleId]="data.visitScheduleId"
                                                                        [selectedAgentId]="externalAssignPayload?.agentId"
                                                                        (onSelect)="onSelectExternalResource($event)">
    </app-visit-plan-external-agents-resource-holders-single-select-list>

    <div class="availability-panel flex-40 layout-column" *ngIf="!!externalAssignPayload?.agentId">
      <span class="br-body-2 font-weight-600 primary-100 availability-title" translate>Availability</span>

      <div class="layout-column time-inputs-container margin-bottom-10">
        <app-bringoz-time-select [selectedTime]="externalAssignPayload.startTime"
                                 ticksInMinutes="15"
                                 [min]="dayStartTime"
                                 [max]="externalAssignPayload.endTime"
                                 [placeholder]="'Start Time' | translate"
                                 (onSelect)="onFromTimeChange($event)">
        </app-bringoz-time-select>
      </div>

      <div class="layout-column time-inputs-container">
        <app-bringoz-time-select [selectedTime]="externalAssignPayload.endTime"
                                 ticksInMinutes="15"
                                 [min]="externalAssignPayload.startTime"
                                 [max]="dayEndTime"
                                 [placeholder]="'End Time' | translate"
                                 (onSelect)="onToTimeChange($event)">
        </app-bringoz-time-select>
      </div>

      <div *ngIf="errorMessage" class="layout-row layout-align-start-center margin-top-10">
        <bringoz-icon iconName="error" fill="#f44336"></bringoz-icon>
        <span class="br-body-2 error-text margin-left-5">{{ errorMessage | translate }}</span>
      </div>
    </div>
  </div>

  <app-bringoz-linear-progress *ngIf="isLoading"></app-bringoz-linear-progress>

  <div class="layout-row layout-align-start-center padding-5 footer-border-top">
    <bringoz-button [type]="'tertiary'"
                    [theme]="'primary'"
                    (onClick)="onCancel();$event.stopPropagation();">
      <span>{{ 'Cancel' | translate }}</span>
    </bringoz-button>

    <span class="flex"></span>

    <bringoz-button [theme]="'secondary'"
                    [isDisabled]="!selectedResourceId && (!externalAssignPayload?.agentId || !!errorMessage || assigning)"
                    (onClick)="onSubmit();$event.stopPropagation();">
      <span>{{ assigning ? ('Assigning...' | translate) : ('Submit' | translate) }}</span>
    </bringoz-button>
  </div>

</div>
